<template>
  <div class="sidebar">
    <ul class="sidebar__dashboard-link">
      <li>
        <a class="sidebar__link" href="#">
          <span class="icon-speed-fast"></span>
          {{ $t("sidebar.dashboard") }}
        </a>
      </li>
    </ul>
    <h3 class="sidebar__identification">{{ $t("sidebar.identification") }}</h3>
    <ul>
      <li>
        <a class="sidebar__link" href="#">
          <span class="icon-speed-fast"></span>
          {{ $t("sidebar.contracts") }}
        </a>
      </li>
      <li>
        <a class="sidebar__link" href="#">
          <span class="icon-speed-fast"></span>
          {{ $t("sidebar.partners") }}
        </a>
      </li>
      <li>
        <a class="sidebar__link" href="#">
          <span class="icon-speed-fast"></span>
          {{ $t("sidebar.beneficiaries") }}
        </a>
      </li>
      <li>
        <a class="sidebar__link" href="#">
          <span class="icon-speed-fast"></span>
          {{ $t("sidebar.garages") }} & {{ $t("sidebar.thirdParties") }}
        </a>
      </li>
    </ul>
    <div class="sidebar-new__claims">
      <ButtonWithIcon icon="icon-file-add" :label="$t('button.new_claim')" />
    </div>
  </div>
</template>

<script>
import ButtonWithIcon from "@/components/button/ButtonWithIcon"

export default {
  name: "SideBar",
  components: { ButtonWithIcon },
}
</script>

<style lang="scss" scoped>
.sidebar {
  background-color: $blue100;
  color: white;
  min-width: 200px;
  ul {
    margin-left: 1.2rem;
  }
  a {
    color: white;
  }
}
.sidebar__dashboard-link {
  margin-top: 3rem;
  margin-bottom: 4rem;
}
.sidebar__link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: white;
  margin-bottom: 1rem;
  &:hover {
    transform: scale(1.02);
  }
  span {
    margin-right: 0.5rem;
    font-weight: bolder;
    font-size: 1.5rem;
    &:hover {
      transform: scale(1);
    }
  }
}
.sidebar__identification {
  margin-left: 0.5rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.sidebar-new__claims {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30vh;
}
</style>
